import React from "react";
import {HeadingText} from "../../components/base/typography/HeadingText.jsx";
import {Paragraph} from "../../components/base/typography/Paragraph.jsx";
import {Button} from "../../components/base/Button/Button.jsx";
import {GridContainerFlex} from "../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";

export const NotFound = () => {
    const handleGoBack = () => {
        window.history.back();
    };

    return (
        <GridContainerFlex justifyContent={"center"} alignItems={"center"} flexDirection={"column"} style={{height: "100vh"}}>
            <GridItemFlex>
                <HeadingText type={"h4"}>404 - Page Not Found</HeadingText>
            </GridItemFlex>
            <GridItemFlex>
                <Paragraph>The page you are looking for does not exist.</Paragraph>
            </GridItemFlex>
            <GridItemFlex>
                <Button onClick={handleGoBack}>Go Back</Button>
            </GridItemFlex>
        </GridContainerFlex>
    );
};